/*

  This Error Boundary is only for the route and first composonent/container to load
*/

import React from "react"
const {detect} = require("detect-browser")
import { baseDomain } from '../../utils/api'

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {error: null, errorInfo: null}
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState(
      {
        error: error,
        errorInfo: errorInfo,
      },
      () => this.send_me_the_error()
    )
  }

  send_me_the_error = () => {
    const browser = detect()

    //compose all necessary information for debugging in the email (text based/ not json)
    let subject = "ERROR at route error boundary "
    let email_text = "<p>ERROR fired from router component</p>"
    email_text += "<p><b>browser URL:</b> " + window.location.href + "</p>"
    email_text += "<p><b>browser:</b><br>- Name: " + browser.name + "<br>- Version: " + browser.version + "<br>- OS: " + browser.os + "</p>"
    email_text += "</p>\n <p><b>Error message:</b></p> <p>" + this.state.error.toString() + "</p>"
    email_text += "</p>\n <p><b>Error component stack:</b></p> <p>" + JSON.stringify(this.state.errorInfo) + "</p>"

    // fetch(baseDomain+'/api/errorboundary/', {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify({ subject: subject, email_text: email_text })
    //         })
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div className="surveybody">
          <div className="row" style={{marginLeft: "0"}}>
            <div className="col-12" style={{height: "100vh", backgroundColor: "black", color: 'white'}}>
              <div className="centerVertical_konsensuskonferenz" style={{textAlign: "center", zIndex: "100", color: 'white'}}>
                <h2 style={{color: 'white'}} >Something went wrong at the Router level :(</h2>
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
              </div>
            </div>
          </div>
        </div>
      )
    }

    // this.send_me_the_error()
    // Normally, just render children
    return this.props.children
  }
}